import { FC } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

import { FieldFile } from './FieldFile';

type FieldFilesProps = {
  files: {
    name: string;
    extension: string;
  }[];
};

export const FieldFiles: FC<FieldFilesProps> = ({ files }) => {
  // TODO crutch
  if (!files || files.length === 0) {
    return '-';
  }

  const firstFile = files[0];
  const more = files.length - 1;

  return (
    <Container>
      <FieldFile className="file" data={firstFile} />
      {more > 0 && <More>+{more}</More>}
    </Container>
  );
};

const Container = styled.div`
  max-width: 300px;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 8px;

  & .file {
    overflow: hidden;
    word-wrap: normal;
  }
`;

// TODO uikit?
const More = styled.div`
  height: 28px;
  padding-inline: 12px;
  border: 1px solid ${COLORS.systemDark100};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;
